 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/Titlepage'
 import A781504084789 from '@/components/9781504084789'
 import A7815040847891 from '@/components/9781504084789-1'
 import A7815040847892 from '@/components/9781504084789-2'
 import A7815040847893 from '@/components/9781504084789-3'
 import A7815040847894 from '@/components/9781504084789-4'
 import A7815040847895 from '@/components/9781504084789-5'
 import A7815040847896 from '@/components/9781504084789-6'
 import A7815040847897 from '@/components/9781504084789-7'
 import A7815040847898 from '@/components/9781504084789-8'
 import A7815040847899 from '@/components/9781504084789-9'
 import A78150408478910 from '@/components/9781504084789-10'
 import A78150408478911 from '@/components/9781504084789-11'
 import A78150408478912 from '@/components/9781504084789-12'
 import A78150408478913 from '@/components/9781504084789-13'
 import A78150408478914 from '@/components/9781504084789-14'
 import A78150408478915 from '@/components/9781504084789-15'
 import A78150408478916 from '@/components/9781504084789-16'
 import A78150408478917 from '@/components/9781504084789-17'
 import A78150408478918 from '@/components/9781504084789-18'
 import A78150408478919 from '@/components/9781504084789-19'
 import A78150408478920 from '@/components/9781504084789-20'
 import A78150408478921 from '@/components/9781504084789-21'
 import A78150408478922 from '@/components/9781504084789-22'
 import A78150408478923 from '@/components/9781504084789-23'
 import A78150408478924 from '@/components/9781504084789-24'
 import A78150408478925 from '@/components/9781504084789-25'
 import A78150408478926 from '@/components/9781504084789-26'
 import A78150408478927 from '@/components/9781504084789-27'
 import LOVE_2 from '@/components/love_2'
 import PREVIEWPREVIEW from '@/components/Preview/preview'
 import PREVIEWCOVER from '@/components/Preview/cover'
 import PREVIEW03_PROLOGUE from '@/components/Preview/03_Prologue'
 import PREVIEW05_PT1_CHAPTER01 from '@/components/Preview/05_Pt1_chapter01'
 import PREVIEW06_PT1_CHAPTER02 from '@/components/Preview/06_Pt1_chapter02'
 import ABA from '@/components/aba'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/9781504084789",
 			"name" : "9781504084789",
 			"component" : A781504084789
 		},
 		{
 			"path" : "/9781504084789-1",
 			"name" : "9781504084789-1",
 			"component" : A7815040847891
 		},
 		{
 			"path" : "/9781504084789-2",
 			"name" : "9781504084789-2",
 			"component" : A7815040847892
 		},
 		{
 			"path" : "/9781504084789-3",
 			"name" : "9781504084789-3",
 			"component" : A7815040847893
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js